import { ReactNode } from "react";
import {
  Fade,
  Slide,
  Hinge,
  Bounce,
  Flip,
  JackInTheBox,
  Roll,
  Rotate,
  Zoom,
  AttentionSeeker,
  Reveal,
} from "react-awesome-reveal";
import { IEffects } from "../interfaces/globalInterface";

interface IProps {
  children: ReactNode;
  effect?: IEffects;
}

const RevealOnScroll = (props: IProps) => {
  const { children, effect } = props;
  function getEffect(newEffect: IEffects, children: ReactNode) {
    switch (newEffect) {
      case "AttentionSeeker":
        return <AttentionSeeker>{children}</AttentionSeeker>;
      case "Bounce":
        return <Bounce>{children}</Bounce>;
      case "Fade":
        return <Fade>{children}</Fade>;
      case "Flip":
        return <Flip>{children}</Flip>;
      case "Hinge":
        return <Hinge>{children}</Hinge>;
      case "JackInTheBox":
        return <JackInTheBox>{children}</JackInTheBox>;
      case "Reveal":
        return <Reveal>{children}</Reveal>;
      case "Roll":
        return <Roll>{children}</Roll>;
      case "Rotate":
        return <Rotate>{children}</Rotate>;
      case "Slide":
        return <Slide>{children}</Slide>;
      case "Zoom":
        return <Zoom>{children}</Zoom>;
      default:
        return <Fade>{children}</Fade>;
    }
  }

  return getEffect(effect ?? "Fade", children);
};

export default RevealOnScroll;
